import './polyfill/polyfill-nodelist-foreach'
import './polyfill/polyfill-console'
import './polyfill/polyfill-custom-event'

import './tracking/ga4'
import './tracking/algolia'

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import morph from '@alpinejs/morph'

Alpine.plugin(intersect)
Alpine.plugin(morph)

// alpine components (data) must be declared before Alpine.start

import './shared-imports'

document.addEventListener('alpine:init', () => {
    document.dispatchEvent(new Event('alpine:bundle'))
})

window.Alpine = Alpine
Alpine.start()

import './misc/legacy-link-decoder'
